import { FieldType } from "@baserow/modules/database/fieldTypes";
import moment from "@baserow/modules/core/moment";

import JobScheduleGridField from "@peninsula/components/JobScheduleGridField";
import JobScheduleFunctionalGridField from "@peninsula/components/JobScheduleFunctionalGridField";
import JobScheduleRowEditField from "@peninsula/components/JobScheduleRowEditField";
import JobScheduleCardField from "@peninsula/components/JobScheduleCardField";
import { formatSchedule, scheduleError } from "@peninsula/jobSchedule";

export class JobScheduleFieldType extends FieldType {
  static getType() {
    return "job_schedule";
  }

  static getIconClass() {
    return "iconoir-calendar";
  }

  getName() {
    return "Job schedule";
  }

  getCanBePrimaryField() {
    return false;
  }

  getGridViewFieldComponent() {
    return JobScheduleGridField;
  }

  getFunctionalGridViewFieldComponent() {
    return JobScheduleFunctionalGridField;
  }

  getRowEditFieldComponent() {
    return JobScheduleRowEditField;
  }

  getCardComponent() {
    return JobScheduleCardField;
  }

  getValidationError(field, value) {
    return scheduleError(value, field.timezone);
  }

  toHumanReadableString(field, value) {
    return formatSchedule(value, field.timezone);
  }

  prepareValueForCopy(field, value) {
    return this.toHumanReadableString(field, value);
  }

  getSort(name, order) {
    return (a, b) => {
      const valueA = a[name]?.start;
      const valueB = b[name]?.start;
      if (valueA === valueB) return 0;
      if (valueA == null) return order === "ASC" ? -1 : 1;
      if (valueB == null) return order === "ASC" ? 1 : -1;
      const difference = moment(valueA).valueOf() - moment(valueB).valueOf();
      return order === "ASC" ? difference : -difference;
    };
  }

  getSortIndicator() {
    return ["text", "1", "9"];
  }
}
